import createReactComponent from '../createReactComponent';
export default createReactComponent('clear-all', 'IconClearAll', [
  ['path', { d: 'M8 6h12', key: 'svg-0' }],
  ['path', { d: 'M6 12h12', key: 'svg-1' }],
  ['path', { d: 'M4 18h12', key: 'svg-2' }],
]);
